import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import TransactionFileFactory from "../../Entity/Factories/TransactionFileFactory";

export default function* transactionFileUpdate(action: ActionInterface): any {
  try {
    const res = yield call(Http.patch, `transaction-file/${action.payload?.transactionFileId}`, {
      ...action.payload
    });
    
    const transactionFile = TransactionFileFactory.create(res.data);
    
    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_UPDATE_SUCCESS,
      payload: {
        transactionFile: transactionFile
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, transactionFile);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchTransactionFileUpdate() {
  yield takeEvery(Constants.GLOBAL_TRANSACTION_FILE_UPDATE_START, transactionFileUpdate);
}
